import { render, staticRenderFns } from "./ed-nav-submenu.component.vue?vue&type=template&id=13cdde43&scoped=true&"
import script from "./ed-nav-submenu.component.ts?vue&type=script&lang=ts&"
export * from "./ed-nav-submenu.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-nav-submenu.component.scss?vue&type=style&index=0&id=13cdde43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cdde43",
  null
  
)

export default component.exports